import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import digitalPaaniLogoV2 from '../../constants/Images/digitalPaaniLogoV2.png';

import { HEADER_LOGO_MAX_HEIGHT, HEADER_LOGO_WIDTH } from './header.constants';
import { useGoToLanding } from './useHeaderActions';

const buttonSx: SxProps<Theme> = { borderRadius: 1 };
const logoSx: SxProps<Theme> = { display: 'block', width: HEADER_LOGO_WIDTH, maxHeight: HEADER_LOGO_MAX_HEIGHT };

export const HomeLogoButton = (): JSX.Element => {
  const { t } = useTranslation();
  const goToLanding = useGoToLanding();

  return (
    <ButtonBase focusRipple onClick={goToLanding} aria-label={t('header.goToHome', 'Go to home')} sx={buttonSx}>
      <Box component="img" src={digitalPaaniLogoV2} alt="" sx={logoSx} />
    </ButtonBase>
  );
};
